import { HttpParams } from "@angular/common/http";

import { SortDirection } from "@core/enums/sort-type";
import { TPagination } from "@custom-types/sorting";
import { SortingParams } from "@features/+shared/sorting-params/sorting-params";

export class ServiceHelper {
  static getListQueryParams(
    searchTerm?: string | undefined,
    pagination?: Partial<TPagination> | undefined
  ): HttpParams {
    let params = new HttpParams({});
    if (
      pagination?.propertyName &&
      ("direction" in pagination || "asc" in pagination)
    ) {
      params = SortingParams.appendParams({
        propertyName: pagination.propertyName,
        direction:
          pagination.direction !== undefined
            ? pagination.direction
            : pagination.asc
              ? SortDirection.Ascending
              : SortDirection.Descending,
      });
    }
    if (searchTerm || pagination?.searchTerm) {
      params = params.append(
        "searchTerm",
        searchTerm ?? pagination?.searchTerm!
      );
    }
    if (pagination?.pageSize && pagination.pageIndex) {
      params = params.append("pageNumber", pagination.pageIndex);
      params = params.append("pageSize", pagination.pageSize);
    }
    return params;
  }
}
